<template>
    <div>
        <v-card>
            <div class="d-flex flex-row">
                <v-card-title
                    class="d-flex grow"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <h3 class="ma-0 font-weight-light">Seguimiento paquetes</h3>
                    <v-btn
                        small
                        fab
                        depressed
                        color="blue"
                        class="ml-auto"
                        @click="openModHeadersTableDialog"
                    >
                        <v-icon color="white" size="25">mdi-pencil</v-icon>
                    </v-btn>
                </v-card-title>
            </div>
            <!-- <v-divider class="test mb-2"></v-divider> -->
            <v-card flat>
                <div>
                    <div class="px-2">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    </div>
                    <v-data-table
                        :headers="headersPackages.filter(({ show }) => show)"
                        :items="packages"
                        :footer-props="footersProps"
                        :page.sync="page"
                        :items-per-page="10"
                        :options.sync="options"
                        :server-items-length="totalEntries"
                        class="elevation-1"
                        :loading="loading || order.isLoadingOrder"
                        :hide-default-footer="loading"
                        :item-class="itemRowBackgroundPackage"
                    >
                        <template v-slot:item.sfid="{ item }">
                            {{
                                item.additionalinfo && item.additionalinfo.sfid
                                    ? item.additionalinfo.sfid
                                    : ''
                            }}
                        </template>
                        <template v-slot:item.tipoVenta="{ item }">
                            {{
                                item.tipoVenta
                                    ? item.tipoVenta == 'PORTA'
                                        ? 'Portabilidad'
                                        : capitalize(
                                              item.tipoVenta.replace('_', ' ')
                                          )
                                    : ''
                            }}
                        </template>
                        <template v-slot:item.tarifa.segment="{ item }">
                            {{ capitalize(item.tarifa.segment) }}
                        </template>
                        <template
                            v-slot:item.oferta.atencion.updatedOn="{ item }"
                        >
                            {{
                                formatDateLarge(item.oferta.atencion.updatedOn)
                            }}
                        </template>
                        <template v-slot:item.lineasAsociadas="{ item }">
                            <div class="d-flex justify-center">
                                <v-menu
                                    v-if="item.lineasAsociadas.length > 1"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="primary"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-phone-plus
                                        </v-icon>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(
                                                tlf, index
                                            ) in item.lineasAsociadas"
                                            :key="index"
                                        >
                                            <v-list-item-title>{{
                                                tlf
                                            }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <div v-else>
                                    {{ item.lineasAsociadas.toString() }}
                                </div>
                            </div>
                        </template>
                        <template v-slot:item.crossSell="{ item }">
                            {{ item.crossSell ? 'Si' : '' }}
                        </template>
                        <template v-slot:item.state="{ item }">
                            <div class="d-flex justify-start">
                                <v-chip
                                    v-if="
                                        item.additionalinfo &&
                                        item.additionalinfo.state &&
                                        item.tipoLinea != 'LINEA_ADICIONAL_SVA'
                                    "
                                    label
                                    class="ml-1 overline mr-1"
                                    :color="
                                        statePackage[item.additionalinfo.state][
                                            'color'
                                        ]
                                    "
                                    medium
                                >
                                    <v-icon left>
                                        mdi-{{
                                            statePackage[
                                                item.additionalinfo.state
                                            ]['icon']
                                        }}
                                    </v-icon>
                                    {{
                                        statePackage[item.additionalinfo.state][
                                            'nombre'
                                        ]
                                    }}
                                </v-chip>
                                <div v-else>No encontrado</div>
                                <v-icon
                                    v-if="
                                        validsOperatorOrders(item) &&
                                        item.additionalinfo &&
                                        item.additionalinfo.orderId
                                    "
                                    @click="
                                        fetchOrderDetail(
                                            item.additionalinfo,
                                            item.id
                                        )
                                    "
                                    class="mr-1"
                                    color="primary"
                                    :disabled="order.isLoadingOrder"
                                    >mdi-update
                                </v-icon>
                                <v-icon
                                    v-if="
                                        order.orderData &&
                                        item.additionalinfo &&
                                        item.additionalinfo.orderId ==
                                            order.orderData.id
                                    "
                                    @click="viewDetailedOrder()"
                                    color="primary"
                                    :disabled="order.isLoadingOrder"
                                    >mdi-eye
                                </v-icon>
                            </div>
                        </template>
                        <template v-slot:item.soldOut="{ item }">
                            <v-icon
                                :color="
                                    item.additionalinfo &&
                                    item.additionalinfo.soldOut
                                        ? 'green'
                                        : 'red'
                                "
                                @click="setSoldOutToggle(item)"
                            >
                                mdi-circle
                            </v-icon>
                        </template>
                        <template v-slot:item.upfrontTotal="{ item }">
                            {{ getUpfrontPorcentual(item) }} €
                        </template>
                    </v-data-table>
                </div>
            </v-card>
        </v-card>
        <v-dialog
            v-model="isOpenViewOrderDetail"
            persistent
            max-width="1200px"
            transition="dialog-top-transition"
        >
            <v-card>
                <OrdersViewDetail />
                <div class="d-flex justify-end pa-2">
                    <v-btn text color="red" @click="closeDialog" class="mr-2">
                        Cerrar
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <ModHeadersTable :headers="headersPackages" />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formatDateLarge } from '@/util/libUtil.js';
import OrdersViewDetail from '@/components/ComercialTeletrabajo/DetailedView/OrdersViewDetail.vue';
import ModHeadersTable from '@/components/GerenciaTeletrabajo/ComercialesTable/ModHeadersTable.vue';

export default {
    name: 'TablaPaquetes',
    components: {
        OrdersViewDetail,
        ModHeadersTable,
    },
    data: () => ({
        isOpenViewOrderDetail: false,
        headersPackages: [
            {
                text: 'SFID',
                value: 'sfid',
                align: 'center',
                show: true,
            },
            {
                text: 'MSISDN',
                value: 'lineasAsociadas',
                align: 'center',
                show: true,
            },
            {
                text: 'Liquidado',
                value: 'soldOut',
                align: 'center',
                show: true,
            },
            {
                text: 'Actualizado',
                value: 'oferta.atencion.updatedOn',
                align: 'center',
                show: true,
            },
            {
                text: 'Tarifa',
                value: 'tarifa.name',
                align: 'left',
                show: true,
            },
            {
                text: 'Operador',
                value: 'tarifa.operator',
                align: 'center',
                show: true,
            },
            {
                text: 'Segmento',
                value: 'tarifa.segment',
                align: 'center',
                show: true,
            },
            {
                text: 'Tipo de venta',
                value: 'tipoVenta',
                align: 'center',
                show: true,
            },
            {
                text: 'Dispositivo',
                value: 'cacharro',
                align: 'center',
                show: true,
            },
            {
                text: 'Seguro',
                value: 'seguro.name',
                align: 'center',
                show: true,
            },
            {
                text: 'Cross sell',
                value: 'crossSell',
                align: 'center',
                show: true,
            },
            {
                text: 'Estado',
                value: 'state',
                align: 'center',
                show: true,
            },
            {
                text: 'Upfront',
                value: 'upfrontTotal',
                align: 'center',
                sortable: false,
                show: true,
            },
        ],
        packages: [],
        search: null,
        page: 1,
        options: {},
        totalEntries: 0,
        footersProps: {
            disableItemsPerPage: false,
            itemsPerPageOptions: [10],
        },
        loading: false,
    }),
    props: {
        currentDate: Date,
    },
    computed: {
        selectedComercial: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .selectedComercial;
            },
            set(val) {
                this.$store.commit(
                    'areaPersonal/calculadora/selectedComercial',
                    val
                );
            },
        },
        ...mapState('liquidacion', {
            isLoadingPackage: (state) => state.package.isLoadingPackage,
        }),
        ...mapState('orders', {
            order: (state) => state.order,
            statePackage: (state) => state.statePackage,
            orderNumberToState: (state) => state.orderNumberToState,
            stateUser: (state) => state.stateUser,
        }),
    },
    methods: {
        formatDateLarge,
        setSoldOutToggle(item) {
            if (!item.additionalinfo) {
                const additionalinfoObject = {
                    soldOut: true,
                    paquete: item.id,
                };

                this.$store
                    .dispatch(
                        'orders/createAdditionalInfo',
                        additionalinfoObject
                    )
                    .then((resp) => {
                        this.packages.find(
                            (item1) => item1.id === item.id
                        ).additionalinfo = resp;
                    });
            } else {
                const additionalinfoObject = {
                    soldOut: !item.additionalinfo.soldOut,
                    actualOrderId: item.additionalinfo.id,
                };

                this.$store
                    .dispatch(
                        'orders/updateAdditionalInfo',
                        additionalinfoObject
                    )
                    .then((resp) => {
                        this.packages.find(
                            (item1) => item1.id === item.id
                        ).additionalinfo = resp;
                    });
            }

            if (this.selectedComercial)
                this.fetchObjetivo({
                    comercialId: this.selectedComercial.id,
                    soldOut: true,
                });
        },
        openModHeadersTableDialog() {
            this.$store.commit('gerencia/isOpenModHeadersDialog', true);
        },
        closeDialog() {
            this.isOpenViewOrderDetail = false;
        },
        viewDetailedOrder() {
            this.isOpenViewOrderDetail = true;
        },
        getPackageStatusFromStateCode(stateCode) {
            return this.stateUser[this.orderNumberToState[stateCode]]
                .packageStatus;
        },
        fetchOrderDetail(packageItem, packageId) {
            this.$store.dispatch(
                'orders/getOrderMoreDetail',
                packageItem.orderId
            );
            this.$store
                .dispatch('orders/getOrderDetail', packageItem.orderId)
                .then(() => {
                    const stateOrder = this.getPackageStatusFromStateCode(
                        this.order.orderData.state
                    );
                    if (
                        stateOrder != packageItem.state ||
                        this.order.orderData.id != packageItem.orderId ||
                        this.order.orderData.sfid != packageItem.sfid
                    ) {
                        const packageStatusItem = {
                            state: stateOrder,
                            orderId: this.order.orderData.id,
                            actualOrderId: packageItem.id,
                            sfid: this.order.orderData.sfid,
                            paquete: packageId,
                        };
                        this.$store
                            .dispatch(
                                'orders/updateAdditionalInfo',
                                packageStatusItem
                            )
                            .then((resp) => {
                                this.packages.find(
                                    (item1) => item1.id === packageId
                                ).additionalinfo = resp;
                            });
                    }
                });
        },
        validsOperatorOrders({ tarifa: { operator } }) {
            return ['YOIGO', 'DBL'].includes(operator);
        },
        itemRowBackgroundPackage: function (item) {
            return item.additionalinfo?.soldOut ? 'verde' : 'rojo';
        },
        getUpfrontPorcentual(item) {
            return item.packageUpfront
                ? (
                      item.packageUpfront *
                      (item.oferta.atencion.comercial.currentReward?.amount *
                          0.01)
                  ).toFixed(2)
                : 0;
        },
        capitalize(word) {
            const lower = word.toLowerCase();
            return word.charAt(0).toUpperCase() + lower.slice(1);
        },
        async update() {
            this.loading = !this.loading;
            try {
                let params = {
                    ...{
                        mes_year_updated_on: this.currentDate,
                        estado: 'VENDIDO',
                    },
                    ...this.options,
                };

                if ('itemsPerPage' in params) {
                    if (this.selectedComercial)
                        params.comercial = this.selectedComercial.id;
                    if (this.search) params.search = this.search;
                    let data = await this.fetchPackage(params);
                    this.packages = data.results;
                    this.totalEntries = data.count;
                }
            } catch (error) {
                console.log(error.message);
            }
            this.loading = !this.loading;
        },
        ...mapActions({
            fetchPackage: 'areaPersonal/liquidacion/fetchPackage',
        }),
        ...mapActions('areaPersonal/calculadora', ['fetchObjetivo']),
    },
    watch: {
        options: {
            immediate: true,
            handler: async function (newVal, oldVal) {
                if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                    return;
                }

                this.update();
            },
        },
        selectedComercial: {
            immediate: true,
            handler(newVal, oldVal) {
                const index = this.headersPackages.findIndex(
                    ({ text }) => text === 'Comercial'
                );

                if (index != -1) {
                    this.headersPackages.splice(index, 1);
                } else {
                    this.headersPackages.splice(1, 0, {
                        text: 'Comercial',
                        value: 'oferta.atencion.comercial.nombreCompleto',
                        align: 'center',
                        show: 'true',
                    });
                }

                this.page = 1;
                this.update();
            },
            // this.options = {};
        },
        currentDate() {
            this.update();
        },
        search(newVal, oldVal) {
            let prev = newVal;
            setTimeout(() => {
                if (prev == this.search) this.update();
            }, 200);
        },
    },
};
</script>

<style>
.verde {
    background-color: rgb(206, 255, 206);
}

.rojo {
    background-color: rgb(255, 191, 191);
}

.azul {
    background-color: #cad3eb;
}
</style>